<template>
<div>
    <div class="maren-sol">
        <el-container class="d-flex-column">
        <h1>Contact us</h1>
        <p>We have our presence across the globe and a<span class="d-block">dedicated development center in India which provides</span> platform to create multiple products with <span class="d-block">vast experience into different technologies,</span></p>
        </el-container>
    </div>
    <el-container class="d-flex-column p-tb50">
      <el-row :gutter="24">
        <el-col :span="10" class="p-t130">
          <div class="location">
            <h3><i class="icon-location4 navyblue-text"></i>India</h3>
            <strong>Maren solutions Pvt Ltd</strong>
            PSR Prime Towers, B-Block <span class="d-block">2nd floor, Beside DLF Gate No: 1, </span> Gachibowli, Hyderabad 500032 
          </div>
          <div class="location">
            <h3><i class="icon-location4 pink-text"></i>Saudi Arabia</h3>
            <strong>Sanar Ecommerce Company LLC</strong>
            Post Box 1900,Khamis Musha<span class="d-block">Asser,Saudi Arabia-61961 </span>
          </div>
         <!-- <div class="location">
            <h3><i class="icon-location4 yellow-text"></i>Dubai</h3>
            <strong>Maren solutions Pvt Ltd</strong>
            PSR Prime Towers, B-Block <span class="d-block">2nd floor, Beside DLF Gate No: 1, </span> Gachibowl, Hyderabad 500032 
          </div>--->
        </el-col>
        <el-col :span="14">
          <h2>Contact us</h2>
          <el-card shadow="never" class="form-bg">
              <img src="../../../public/img/contactus/triangel.svg" alt="Triangel" class="triangel" />
              <img src="../../../public/img/contactus/oval.svg" alt="Oval" class="oval" />
              <el-form :model="form">
                <el-row :gutter="30">
                    <el-col :span="12">
                        <el-form-item label="Name">
                            <el-input v-model="form.name" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Company">
                            <el-input v-model="form.company" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Phone Number">
                            <el-input v-model="form.number" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Email">
                            <el-input v-model="form.email" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Comments">
                            <el-input type="textarea" :rows="8" v-model="form.comment" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="text-center">
                      <el-button type="primary" round size="large" @click="onSubmit">Submit</el-button>                        
                    </el-col>
                </el-row>
              </el-form>
          </el-card>
        </el-col>
      </el-row>
    </el-container>
</div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
  export default {
  watch:{
    scobj:{
      immediate:true,
      deep: true,
      handler(){
        if(this.scobj){
          this.scobj = false
          var element = this.$refs['flightRef'];
          var top = element.offsetTop;
          window.scrollTo(0, top);
        }
      }
    }
  },
    computed: mapState(['currentLanguage']),
    title () {
      return this.currentLanguage == 'en' ? '' : ''
    },
    components:{  },
    data() {
      return {
        form: {
            name: '',
            comment:'',
            email:'',
            number:'',
            company:'',
          }
        }
      },
      methods: {
        toggleBodyClass(addRemoveClass, className) {
          const el = document.body;

          if (addRemoveClass === 'addClass') {
            el.classList.add(className);
          } else {
            el.classList.remove(className);
          }
        },
      },
        mounted() {
          this.toggleBodyClass('addClass', 'contactus');
        },
        destroyed() {
          this.toggleBodyClass('removeClass', 'contactus');
        }
    };
</script>


// WEBPACK FOOTER //
// Contactus.vue